interface PageContainerProps {
  layout: string;
  componentMap: { [key: string]: React.ElementType };
  props?: any;
}

const PageContainer: React.FC<PageContainerProps> = ({
  layout,
  componentMap,
  props = {},
}) => {
  return (
    <>
      {Array?.isArray(layout) &&
        layout.map((comp: string) => {
          const Component = componentMap[comp];

          return !Component ? null : (
            <Component key={comp} props={props?.[comp]} />
          );
        })}
    </>
  );
};

export default PageContainer;
